import { selectize } from '@selectize/selectize'
import { Fancybox } from '@fancyapps/ui'
import { searchSpinner, updateQueryStringParameter, getRexDocuments } from './custom-functions.js'
import { slick } from 'slick-carousel'
import { Tab } from './bootstrap.js'

//Global list of select
const selectizeInstances = [];
// selectize all select elements with default settings.
window.selectizeTheWorld = () => {
	jQuery('select:not(".unselectized")').selectize({
		plugins: ['remove_button', 'restore_on_backspace', 'clear_button', 'auto_position'],
		delimiter: ',',
		persist: false,
		create: function (input) {
			return {
				value: input, text: input,
			}
		},
		onFocus: function () {
			selectizeInstances.forEach(function (instance) {
				if (instance !== this) {
					instance.close();
				}
			}, this);
		},
		onInitialize: function () {
			selectizeInstances.push(this);
		}
	})
}
document.addEventListener('DOMContentLoaded', function () {
	// Activate tab on page load
	const hash = window.location.hash;
	if (hash) {
		const tabTrigger = document.querySelector(`a[data-bs-toggle="tab"][href="${hash}"]`);
		if (tabTrigger) {
			new Tab(tabTrigger).show();
		}
	}

	// Update URL hash when tab is clicked
	const tabLinks = document.querySelectorAll('a[data-bs-toggle="tab"]');
	tabLinks.forEach(function (tab) {
		tab.addEventListener('click', function (e) {
			const hash = this.getAttribute('href');
			const newUrl = hash === '#all'
				? window.location.href.split('#')[0]
				: window.location.href.split('#')[0] + hash;
			history.replaceState(null, null, newUrl);
		});
	});
});
// Update the sort order when clicked.
window.changePropertySortOrder = () => {

	const sortOrder = document.getElementById('epl-sort-listings-');

	if (sortOrder) {
		jQuery('#epl-sort-listings-').selectize({
			onChange: function (value, isOnInitialize) {
				if (value !== '') {
					let url = window.location.href;
					let newUrl = updateQueryStringParameter(url, 'sortby', value);
					window.location.replace(newUrl);
				}
			}
		});
	}
}

/**
 * Once the page loads, do our stuff!
 */
document.addEventListener('DOMContentLoaded', function () {

	// Fix for the sort order tool from EPL on property archive pages.
	changePropertySortOrder();

	// Check for submit buttons and add spinner.
	searchSpinner();

	// Enables Selectize on all select elements.
	selectizeTheWorld();

	// Get Fancybox going.
	Fancybox.bind('[data-fancybox]', {})

	// Enable Tooltips for BootStrap 5.3.
	const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
	tooltipTriggerList.forEach(tooltipTriggerEl => new understrap.Tooltip(tooltipTriggerEl))

	// Get the contract link element, and if it exists, load the data when the dropdown is clicked.
	const documentLinks = document.getElementById('contract-links');
	if (documentLinks) {
		documentLinks.addEventListener('show.bs.dropdown', event => {
			getRexDocuments(documentLinks.dataset.id)
		});
	}

	//Floating form
	var input = document.querySelector('.floating-form .form-control');

	function checkInput() {
		if (input) {
			var label = input.closest('.gfield').querySelector('.form-label');
			if (input.value !== '' || input === document.activeElement) {
				label.classList.add('float-label');
			} else {
				label.classList.remove('float-label');
			}
		}
	}

	if (input) {
		input.addEventListener('focus', checkInput);
		input.addEventListener('blur', checkInput);
		input.addEventListener('input', checkInput);
	}

	// Initial check
	checkInput();

	function test() {
		return $.ajax({ // <----- Notice the return statement here
			url: url,
			type: 'GET',
			success: {
				if(input) {
					checkInput();
					input.addEventListener('focus', checkInput);
					input.addEventListener('blur', checkInput);
					input.addEventListener('input', checkInput);
				}
			}
		});
	}

});

//Slick Slider
document.addEventListener('DOMContentLoaded', function () {
	var nextButtons = document.querySelectorAll('.slick-static-next-btn');
	nextButtons.forEach(function (button) {
		button.addEventListener('click', function () {
			var closestParent = this.closest('.slick-slider-block');
			jQuery(closestParent).slick('slickNext');
		});
	});

	//ACF Block - Slick Slider
	if (document.querySelectorAll('.slick-slider-block')) {
		var sliders = document.querySelectorAll('.slick-slider-block');
		sliders.forEach(function (slider) {
			jQuery(slider).slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				infinite: true,
				easing: 'linear',
				adaptiveHeight: true,
				autoplay: true,
				autoplaySpeed: 4000,
			});
		});
	}

	//Testimonials
	if (document.querySelectorAll('.testimonials-slider')) {
		var sliders = document.querySelectorAll('.testimonials-slider');
		sliders.forEach(function (slider) {
			jQuery(slider).slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				easing: 'linear',
				adaptiveHeight: true,
				arrows: true,
				prevArrow: '<div class="slick-prev cursor-pointer px-12px"><i class="bi bi-chevron-left"></i></div>',
				nextArrow: '<div class="slick-next cursor-pointer px-12px"><i class="bi bi-chevron-right"></i></div>',
				appendArrows: '.testimonials-arrows'
			});
		});
	}

	//More Properties
	if (document.querySelectorAll('.more-properties-slider')) {
		var sliders = document.querySelectorAll('.more-properties-slider');
		sliders.forEach(function (slider) {
			jQuery(slider).slick({
				centerMode: true,
				centerPadding: '24px',
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				easing: 'linear',
				adaptiveHeight: true,
				arrows: false,
				mobileFirst: true,
				responsive: [
					{
						breakpoint: 541,
						settings: 'unslick',
					}
				]
			});
		});
	}
});

//Reset Button - Unset Selectize
if (document.getElementById('btn-reset')) {
	document.getElementById('btn-reset').addEventListener('click', function () {
		var selectizeControls = document.querySelectorAll('.enable-clear .selectize-control');
		selectizeControls.forEach(function (selectizeControl) {
			var clearButton = selectizeControl.querySelector('.clear');
			if (clearButton) {
				clearButton.click();
			}
		});

		jQuery('.enable-clear input[type="radio"]').removeAttr('checked');
		jQuery('.dropdown-toggle--sort').text('Default');
	});
}

//Selectize - Copy Options
if (jQuery('#property_location_main-selectized')) {
	jQuery('#property_location_main-selectized').on('click', function () {
		var options = jQuery('#property_location option:selected').sort().clone();
		jQuery('#property_location').append(options);
	});
}
if (jQuery('#property_location-selectized')) {
	jQuery('#property_location-selectized').on('click', function () {
		var options = jQuery('#property_location_main option').sort().clone();
		jQuery('#property_location_main').append(options);
	});
}

jQuery(document).ready(function ($) {
	var inc = 0;
	if ($('#property_location_main')) {
		$('#property_location_main').selectize({
			plugins: ['remove_button', 'restore_on_backspace', 'clear_button', 'auto_position'],
			onChange: function (value) {
				copySelectizeOptions(value, $('#property_location_main'), $('#property_location'));
			},
			onFocus: function () {
				selectizeInstances.forEach(function (instance) {
					if (instance !== this) {
						instance.close();
					}
				}, this);
			},
			onInitialize: function () {
				selectizeInstances.push(this);
			}
		});

	}
	if ($('#property_location')) {
		$('#property_location').selectize({
			plugins: ['remove_button', 'restore_on_backspace', 'clear_button', 'auto_position'],
			onChange: function (value) {
				copySelectizeOptions(value, $('#property_location'), $('#property_location_main'));
			},
			onFocus: function () {
				selectizeInstances.forEach(function (instance) {
					if (instance !== this) {
						instance.close();
					}
				}, this);
			},
			onInitialize: function () {
				selectizeInstances.push(this);
			}
		});
	}

	function copySelectizeOptions(value, source, destination) {
		var $sourceSelect = source.selectize();
		var sourceSelectize = $sourceSelect[0].selectize;
		var selectedValues = sourceSelectize.getValue();

		var $destinationSelect = destination.selectize();
		var destinationSelectize = $destinationSelect[0].selectize;
		destinationSelectize.clear();

		selectedValues.forEach(function (value) {
			var option = sourceSelectize.getOption(value);
			destinationSelectize.addOption(option, true);
			destinationSelectize.addItem(value, true);
			sourceSelectize.addOption(option, true);
			sourceSelectize.addItem(value, true);
		});
	}
});

jQuery(document).ready(function ($) {
	if ($('.video-modal').length) {
		var modal = $('.video-modal');
		var iframe = modal.find('iframe');
		var urlsrc = new URL(iframe.attr('src'));

		if (modal.length) {

			modal.on('show.bs.modal', function () {
				urlsrc.searchParams.set('autoplay', 'true');
				iframe.attr('src', urlsrc.toString());
			})

			modal.on('hidden.bs.modal', function () {
				urlsrc.searchParams.set('autoplay', 'false');
				iframe.attr('src', '');
			})
		}
	}
});

//Google Maps
import { Loader } from "@googlemaps/js-api-loader"

if (document.querySelectorAll('input[name="auction_date"]')) {
	var auctionRadios = document.querySelectorAll('input[name="auction_date"]');
	for (var i = 0; i < auctionRadios.length; i++) {
		auctionRadios[i].addEventListener('click', function () {

			var inspectionRadios = document.querySelectorAll('input[name="inspection_date"]');
			for (var j = 0; j < inspectionRadios.length; j++) {
				inspectionRadios[j].removeAttribute('checked');
			}

			// Submit the form
			document.querySelector('#form-search').submit();
		});
	}
}

if (document.querySelectorAll('input[name="inspection_date"]')) {
	var auctionRadios = document.querySelectorAll('input[name="inspection_date"]');
	for (var i = 0; i < auctionRadios.length; i++) {
		auctionRadios[i].addEventListener('click', function () {

			var inspectionRadios = document.querySelectorAll('input[name="auction_date"]');
			for (var j = 0; j < inspectionRadios.length; j++) {
				inspectionRadios[j].removeAttribute('checked');
			}

			// Submit the form
			document.querySelector('#form-search').submit();
		});
	}
}

